/* eslint-disable no-useless-escape */
export const PATTERN_PASSWORD = /^(?=.*)[a-zа-яё0-9^\S]{8,25}$/i;
export const PATTERN_EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PATTERN_URL =
  /^(https?:\/\/)?(([\w\.\-@]+)(:[\w.\-@]+)?@)?([a-zA-Z0-9-]+\.)+[a-zA-Z0-9:]{2,}(\/[-\w\.\/?%&=~]*)?|(https?:\/\/)?no-url\/?$/;
export const PATTERN_STORE_URL =
  /^(https?:\/\/)?(([\w\.\-@]+)(:[\w.\-@]+)?@)?([a-zA-Z0-9-]+\.)+[a-zA-Z0-9:]{2,}(\/[-\w\.\/?%&=~]*)?$/;
export const PATTERN_DATE_TIME = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
